import type { FaireProductEntity } from "../../entity_types/product";

export const p_3vyk6dee9m: FaireProductEntity = {
  token: "p_3vyk6dee9m",
  type: "product",
  name: "Macaroni 2-in-1 Candle holder - Tapers & Tealights - Blue",
  brandToken: "b_d72c56fe",
  brandName: "54 Celsius",
  imageUrl:
    "https://cdn.faire.com/fastly/5a4cf9fb20d751c235f48f7348301d4e34cfbe1c49d727a5046ec7646478abb5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee47d36c34dec73cee5e25816b11773512137913600c30f0dace7890dd69b96f.jpeg",
    "https://cdn.faire.com/fastly/b23f58976e15431f66cb9ced5826ad938fe4096f0caffe0df3382303941e8e4a.jpeg",
    "https://cdn.faire.com/fastly/1250480726e3ddd7dcba16d76a3666ab3d2708917ec9da2daf598c2c98fd2afa.jpeg",
    "https://cdn.faire.com/fastly/c9d678c861df3a6a41eab1f88273a5d129c3e9820880adad8c1da58cda7d23e7.jpeg",
    "https://cdn.faire.com/fastly/4c640cbe118f65bcdb05f6e8abc74dc0e9c98ebce8c9f381a3469e456bcc16e5.jpeg",
  ],
  priceDollars: 17.5,
  description:
    'Macaroni Candle Holders - Use it as a taper candle holder, or flip it over and use it as a tea-light candle holder. Its strong steel construction means it will last generations. Available in royal blue and black. Designed by Lex Pott.\n\nPairs well with our beeswax tapers, colored taper candles, and Rope & Pivot Candles.\n\n𝗣𝗿𝗼𝗱𝘂𝗰𝘁 𝗜𝗻𝗳𝗼𝗿𝗺𝗮𝘁𝗶𝗼𝗻:\n• One side for tealights another side for 7/8" (22mm) taper candles.\n• Material: Powder coated steel\n• Size: 4.25 x 3.5 x 2.5" (10.8cm x 9cm x 6.6cm)\n• Packaging: Comes in a beautifully designed gift box',
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:12.166Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
